/* eslint-disable import/prefer-default-export */
export const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
